import { render, staticRenderFns } from "./InactiveSubscription.vue?vue&type=template&id=87673ce4&scoped=true&"
import script from "./InactiveSubscription.vue?vue&type=script&lang=js&"
export * from "./InactiveSubscription.vue?vue&type=script&lang=js&"
import style0 from "./InactiveSubscription.vue?vue&type=style&index=0&id=87673ce4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87673ce4",
  null
  
)

export default component.exports